var map = {
	"./extrato/router/routes.js": "3dd9",
	"./integracoes/router/routes.js": "52f3",
	"./pagamento-boleto/router/routes.js": "04a6",
	"./pagamento-darf/router/routes.js": "9b80",
	"./pix/router/routes.js": "9184",
	"./sistema/router/routes.js": "202d",
	"./transacoes/router/routes.js": "5ff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5340";